module.exports = __webpack_public_path__ + "static/media/golunapark.6a96473c.png";